import React from 'react';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';

import RestaurantPartnerSection from './RestaurantPartnerSection';

import s from './RestaurantPartners.css';

class RestaurantPartners extends React.Component {

    render() {
        const { formatMessage } = this.props.intl;
        const { homepage } = this.props;
        let partners = [1, 2, 3];

        return (
            <div className={s.root}>
                <Container fluid>
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12} className={s.noPadding}>
                            <div className={s.positionRelative}>
                                <div className={cx(s.textCenter, s.headerMargin)}>
                                    <h1 className={s.headerText}>
                                        {homepage?.infoTitle4}
                                    </h1>
                                    <p className={s.headerSubText}>
                                        {homepage?.infoContent4}
                                    </p>
                                </div>
                                <div className={s.orderDisplayGrid}>
                                    {
                                        partners?.map((item, key) => {
                                            return <RestaurantPartnerSection
                                                key={key}
                                                title={homepage['infoTitle' + item]}
                                                Image={homepage['infoImage' + item]}
                                            />
                                        })
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div >
        );
    }
}

export default injectIntl(withStyles(s)(RestaurantPartners));